import {requests} from "../../../RestFullApi/api";
import {favoApiType} from "./favo.interface";

export const favo = {
    getPosts: (user:any): Promise<favoApiType[]> =>
        requests.get(`favo/All/${user}/`)
}
